// Components
import Logo from "~components/Logo"
import NewPasswordForm from "~components/password-reset/NewPassword"
import { AuthLayout, AuthContainer, AuthVersionBadge } from "~styled/auth"
import { APP_VERSION } from "~constants/config"

// Custom Hooks
import useResetPasswordPath from "~hooks/useResetPasswordPath"

const PasswordResetPage = () => {
  // Using custom hooks
  const isResettingPassword = useResetPasswordPath()

  return !isResettingPassword ? null : (
    <AuthLayout>
      <AuthContainer>
        <Logo />
        <NewPasswordForm />
        <AuthVersionBadge>{APP_VERSION}</AuthVersionBadge>
      </AuthContainer>
    </AuthLayout>
  )
}

export default PasswordResetPage
